export default __webpack_public_path__ + "5a231fa2a3b774dab070c4946cb9c340.png";